import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export function useDownloadGstInvoices() {
  const {
    mutate: downloadGstInvoices,
    isLoading: isDownloadingGstInvoicesLoading,
    isSuccess: isDownloadingGstInvoicesSuccess,
    variables,
  } = useMutation({
    mutationFn: (data: {
      invoiceDate: {
        from: string;
        to: string;
      };
    }) =>
      FinanceApprovalService.downloadGstInvoices(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: false },

    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({ queryKey: DOWNLOADS_LIST_QUERY_KEY });
      }, 1000);
    },
  });

  return {
    downloadGstInvoices,
    isDownloadingGstInvoicesLoading,
    isDownloadingGstInvoicesSuccess,
    variables,
  };
}
